module.exports = __webpack_public_path__ + "media/ahoy.7fdd43ab.wav";